/**
 * @generated SignedSource<<5c6cb89134a2da01aade68000d1ec0e6>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type AssetFileType = "document" | "image" | "subtitle" | "unknown" | "video" | "%future added value";
export type OrderDirection = "ASC" | "DESC" | "%future added value";
export type OrganizationAssetsOrderByFieldFilter = "name" | "size" | "times_used" | "upload_date" | "%future added value";
export type OrganizationAssetsOrderByInput = {
  direction: OrderDirection;
  field: OrganizationAssetsOrderByFieldFilter;
};
export type AdminMediaLibraryListPagePaginationQuery$variables = {
  after?: string | null;
  before?: string | null;
  fileType?: AssetFileType | null;
  first?: number | null;
  id: string;
  last?: number | null;
  orderBy?: OrganizationAssetsOrderByInput | null;
  search?: string | null;
};
export type AdminMediaLibraryListPagePaginationQuery$data = {
  readonly node: {
    readonly " $fragmentSpreads": FragmentRefs<"AdminMediaLibraryListPage_PaginationFragment">;
  } | null;
};
export type AdminMediaLibraryListPagePaginationQuery = {
  response: AdminMediaLibraryListPagePaginationQuery$data;
  variables: AdminMediaLibraryListPagePaginationQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "after"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "before"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "fileType"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "first"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "id"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "last"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "orderBy"
},
v7 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "search"
},
v8 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v9 = [
  {
    "kind": "Variable",
    "name": "after",
    "variableName": "after"
  },
  {
    "kind": "Variable",
    "name": "before",
    "variableName": "before"
  },
  {
    "kind": "Variable",
    "name": "fileType",
    "variableName": "fileType"
  },
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  },
  {
    "kind": "Variable",
    "name": "last",
    "variableName": "last"
  },
  {
    "kind": "Variable",
    "name": "orderBy",
    "variableName": "orderBy"
  },
  {
    "kind": "Variable",
    "name": "search",
    "variableName": "search"
  }
],
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "totalCount",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "AdminMediaLibraryListPagePaginationQuery",
    "selections": [
      {
        "alias": null,
        "args": (v8/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "args": (v9/*: any*/),
            "kind": "FragmentSpread",
            "name": "AdminMediaLibraryListPage_PaginationFragment"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/),
      (v4/*: any*/)
    ],
    "kind": "Operation",
    "name": "AdminMediaLibraryListPagePaginationQuery",
    "selections": [
      {
        "alias": null,
        "args": (v8/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v10/*: any*/),
          (v11/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": (v9/*: any*/),
                "concreteType": "AssetNodeConnection",
                "kind": "LinkedField",
                "name": "assets",
                "plural": false,
                "selections": [
                  (v12/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "AssetNodeEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "cursor",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Asset",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v11/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "name",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "url",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "sizeBytes",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "fileType",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "mimeType",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "AssetUsageNodeConnection",
                            "kind": "LinkedField",
                            "name": "assetUsages",
                            "plural": false,
                            "selections": [
                              (v12/*: any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "hasSubtitles",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "muxAssetPlaybackId",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "aspectRatio",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "videoDuration",
                            "storageKey": null
                          },
                          (v10/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PageInfoObjectType",
                    "kind": "LinkedField",
                    "name": "pageInfo",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "endCursor",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "startCursor",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "hasNextPage",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "hasPreviousPage",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "kind": "ClientExtension",
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "__id",
                        "storageKey": null
                      }
                    ]
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": (v9/*: any*/),
                "filters": [
                  "fileType",
                  "search",
                  "orderBy"
                ],
                "handle": "connection",
                "key": "AdminMediaLibraryListPage__assets",
                "kind": "LinkedHandle",
                "name": "assets"
              }
            ],
            "type": "Organization",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "a6cba26431c15e40120b975b76de74c0",
    "id": null,
    "metadata": {},
    "name": "AdminMediaLibraryListPagePaginationQuery",
    "operationKind": "query",
    "text": "query AdminMediaLibraryListPagePaginationQuery(\n  $after: String\n  $before: String\n  $fileType: AssetFileType\n  $first: Int\n  $last: Int\n  $orderBy: OrganizationAssetsOrderByInput\n  $search: String\n  $id: ID!\n) {\n  node(id: $id) {\n    __typename\n    ...AdminMediaLibraryListPage_PaginationFragment_U1mka\n    id\n  }\n}\n\nfragment AdminMediaLibraryListPage_PaginationFragment_U1mka on Organization {\n  id\n  assets(first: $first, after: $after, last: $last, before: $before, fileType: $fileType, search: $search, orderBy: $orderBy) {\n    totalCount\n    edges {\n      cursor\n      node {\n        id\n        ...AdminMediaLibraryListTableRowFragment\n        __typename\n      }\n    }\n    pageInfo {\n      endCursor\n      startCursor\n      hasNextPage\n      hasPreviousPage\n    }\n  }\n}\n\nfragment AdminMediaLibraryListTableRowFragment on Asset {\n  id\n  name\n  url\n  sizeBytes\n  fileType\n  mimeType\n  assetUsages {\n    totalCount\n  }\n  hasSubtitles\n  ...UpdateAssetButtonFragment\n  ...DeleteAssetButtonFragment\n}\n\nfragment DeleteAssetButtonFragment on Asset {\n  id\n  assetUsages {\n    totalCount\n  }\n}\n\nfragment DiscoVideoFragment on Asset {\n  id\n  url\n  name\n  muxAssetPlaybackId\n  aspectRatio\n  videoDuration\n}\n\nfragment UpdateAssetButtonFragment on Asset {\n  ...UpdateAssetFormFragment\n}\n\nfragment UpdateAssetFormFieldsFragment on Asset {\n  url\n  fileType\n  ...DiscoVideoFragment\n}\n\nfragment UpdateAssetFormFragment on Asset {\n  id\n  name\n  ...UpdateAssetFormFieldsFragment\n}\n"
  }
};
})();

(node as any).hash = "5d1e87a3fb9b41576603c417245b7d7c";

export default node;
